export interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  userId: string | null;
  userEmail: string | null;
  loading: boolean;
  error: string | null;
  resetPasswordLoading: boolean;
  resetPasswordError: string | null;
  resetPasswordSuccess: boolean;
}

export const initialAuthState: AuthState = {
  isAuthenticated: false,
  token: null,
  userId: null,
  userEmail: null,
  loading: false,
  error: null,
  resetPasswordLoading: false,
  resetPasswordError: null,
  resetPasswordSuccess: false
};

